<script setup>
// Comparativo com o período anterior (R3.11).
//
// O ponto que justifica um componente em vez de duas linhas repetidas: **subir nem sempre é
// bom**. Transbordo, insatisfeitos e abandono são melhores quando caem. A primeira versão do
// comparativo da Jornada pintava qualquer alta de verde, então "transbordo subiu 12 pontos"
// aparecia como boa notícia num relatório que vai para a diretoria.
//
// Por isso quem usa declara `melhorQuando`. Sem declarar, o padrão é "sobe", que serve para a
// maioria (CSAT, resolvidas, autoatendimento).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  valor: { type: Number, default: null },
  // 'pts' para diferença em pontos · '%' para variação de volume
  sufixo: { type: String, default: 'pts' },
  melhorQuando: { type: String, default: 'sobe' },
});

const { t } = useI18n();

// null = não havia período anterior comparável. Some, em vez de mostrar 0 e sugerir uma
// estabilidade que ninguém mediu.
const temValor = computed(
  () => props.valor !== null && props.valor !== undefined
);
const parado = computed(() => temValor.value && props.valor === 0);
const bom = computed(() =>
  props.melhorQuando === 'desce' ? props.valor < 0 : props.valor > 0
);

const cor = computed(() => {
  if (parado.value) return 'text-n-slate-10';
  return bom.value ? 'text-n-teal-11' : 'text-n-ruby-11';
});

const seta = computed(() => {
  if (parado.value) return '=';
  return props.valor > 0 ? '▲' : '▼';
});

const texto = computed(() => {
  if (parado.value) return t('RELATORIOS.DELTA.ESTAVEL');
  const n = Math.abs(props.valor).toLocaleString('pt-BR');
  return props.sufixo === '%' ? `${n}%` : `${n} ${props.sufixo}`;
});
</script>

<template>
  <span
    v-if="temValor"
    class="text-xs font-medium"
    :class="cor"
    :title="t('RELATORIOS.DELTA.TITULO')"
  >
    {{ seta }} {{ texto }}
  </span>
</template>
